<div class="creative-budget-container">
    <span style="margin-left: 7px;" class="ml-2">|</span>
    <label class="mx-2 creative-budget-cell">Budget:</label>
    <span tooltipPosition="top" [pTooltip]="'Budgets are optional and only visible to non-clients. HUB will insert $1 into the delivery platforms if Budget is not set when sending to API.'" tooltipStyleClass="tooltipStyle" class="fal fa-info-circle" style="margin-right: 5px;"></span>
    
    <!-- View Mode -->
    <ng-container *ngIf="!isEditingBudget; else showEditBudget">

        <ng-container *ngIf="creative.budget != null && creative.budget != 0; else notSet">
            <label class="mr-2 creative-budget-value"><strong>
                {{ creative.budget | currency:'USD':'symbol':'1.0-0' }}
                </strong>
            </label>
        </ng-container>

        <ng-template #notSet>
            <strong  class="mr-2">Not set</strong>
        </ng-template>
        
        <button
            pButton
            type="button"
            class="p-button-sm creative-edit-btn"
            (click)="editBudget()"
            [disabled]="isEditDisabled(creative)">
            Edit
        </button>

    </ng-container>

    <!-- Edit Mode -->
    <ng-template #showEditBudget>

        <p-inputNumber
            [(ngModel)]="editableBudget"
            mode="currency"
            currency="USD"
            locale="en-US"
            [min]="0"
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            styleClass="mr-2">
        </p-inputNumber>

        <button
            pButton
            label="Save"
            class="p-button-sm mr-2 bd-highlight edge-button creative-save-btn"
            (click)="saveBudget()">
        </button>

        <button
            pButton
            label="Cancel"
            class="p-button-sm edge-no-button creative-cancel-btn"
            (click)="cancelBudget()">
        </button>

    </ng-template>
</div>